<template>
  <stacked-layout>
    <template v-slot:first>
      <template v-if="!subreports.summationCharts.loading">
        <v-col cols="12" class="cols-lg-5">
          <bw-summation
              class="flex-grow-1"
              :settings="subreports.summationCharts.summations.daily"
          ></bw-summation>
        </v-col>
        <v-col cols="12" class="cols-lg-5">
          <bw-summation
              class="flex-grow-1"
              :settings="subreports.summationCharts.summations.weekly"
          ></bw-summation>
        </v-col>
        <v-col cols="12" class="cols-lg-5">
          <bw-summation
              class="flex-grow-1"
              :settings="subreports.summationCharts.summations.monthly"
          ></bw-summation>
        </v-col>
        <v-col cols="12" class="cols-lg-5">
          <bw-summation
              class="flex-grow-1"
              :settings="subreports.summationCharts.summations.quarterly"
          ></bw-summation>
        </v-col>
        <v-col cols="12" class="cols-lg-5">
          <bw-summation
              class="flex-grow-1"
              :settings="subreports.summationCharts.summations.yearly"
          ></bw-summation>
        </v-col>
      </template>
      <template v-else>
        <v-progress-circular
            indeterminate
            color="primary"
        ></v-progress-circular>
      </template>
    </template>
    <template v-slot:second>
      <table-report-wr
          :settings="subreports.productRedemptions"
          :partner="partner"
          :helper="reportHelper"
      ></table-report-wr>
    </template>
    <template v-slot:third>
      <table-report-wr
          :settings="subreports.productRedemptionsWithAttrs"
          :partner="partner"
          :helper="reportHelper"
      ></table-report-wr>
    </template>
    <template v-slot:fourth>
      <chart-report-wr
          :settings="subreports.redemptionsByPass"
          :partner="partner"
      ></chart-report-wr>
    </template>
    <template v-slot:fifth>
      <template>
        <v-col cols="12" lg="6">
          <chart-report-wr
              :settings="subreports.redemptionsByDay"
              :partner="partner"
          ></chart-report-wr>
        </v-col>
        <v-col cols="12" lg="6">
          <chart-report-wr
              :settings="subreports.redemptionsByHour"
              :partner="partner"
          ></chart-report-wr>
        </v-col>
      </template>
    </template>
    <template v-slot:sixth>
      <table-report-wr
          :settings="subreports.customerRedemptions"
          :partner="partner"
          :helper="reportHelper"
      ></table-report-wr>
    </template>
    <template v-slot:seventh>
      <div id="exportContainer"></div>
    </template>
  </stacked-layout>
</template>


<script>
import StackedLayout from '@components/Layouts/StackedLayout';
import TableReportWr from "../components/tableReportWr";
import ChartReportWr from "../components/chartReportWr";
import BwSummation from "../components/summation";
import ReportHelper from "../reportHelper.js";

export default {
  components: {
    StackedLayout,
    TableReportWr,
    ChartReportWr,
    BwSummation
  },
  props: ReportHelper.propsObject,
  watch: ReportHelper.watchObject,
  data: function () {
    return ReportHelper.formatData({
      filters: {
        startDateTime: moment().startOf('year').format('YYYY-MM-DDTHH:mm:ss'),
        endDateTime: moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
        dealIds: [],
      },
      subreports: {
        summationCharts: {
          tableData: {
            params: {functionName: 'summations'},
          },
          summations: {
            daily: {
              label: `Daily Redemptions`,
              showComparison: true,
              description: "% change compares today to yesterday's redemptions"
            },
            weekly: {
              label: `Weekly Redemptions`,
              showComparison: true,
              description: '% change shows last week up to today. First day of week is Monday'
            },
            monthly: {
              label: `Monthly Redemptions`,
              showComparison: true,
              description: '% change compares to last month up to today.'
            },
            quarterly: {
              label: `Quarterly Redemptions`,
              showComparison: true,
              description: '% change compares to last full quarter.'
            },
            yearly: {
              label: `Annual Redemptions`,
              showComparison: true,
              description: '% change compares to last year up to today.'
            }
          }
        },
        productRedemptions: {
          tableData: {
            label: `Redemptions`,
            columnOptions: {
              product: {name: 'Product'},
              revenue: {name: 'Revenue', format: 'currency', align: 'end'},
              qty: {name: 'Redemptions', align: 'end'}
            },
            checkedColumns: ['product', 'revenue', 'qty'],
            params: {functionName: 'productRedemptions'},
            totalizer: {
              fieldName: 'product',
              totalFieldName: 'qty',
              onEmpty: {product: 'Total', revenue: 0, qty: 0,}
            }
          },
        },
        productRedemptionsWithAttrs: {
          tableData: {
            label: `Redemptions by Attributes`,
            columnOptions: {
              product: {name: 'Product'},
              attribute: {name: 'Attribute'},
              revenue: {name: 'Revenue', format: 'currency', align: 'end'},
              qty: {name: 'Redemptions', align: 'end'}
            },
            checkedColumns: ['product', 'attribute', 'revenue', 'qty'],
            params: {functionName: 'productRedemptions', addAttributes: true},
            totalizer: {
              fieldName: 'product',
              totalFieldName: 'qty',
              onEmpty: {product: 'Total', revenue: 0, qty: 0,}
            }
          },
        },
        redemptionsByPass: {
          tableData: {
            params: {functionName: 'redemptionsByPass'},
          },
          chartData: {
            label: `Redemption by Pass`,
            chart: {
              chart: {
                type: 'line'
              },
              title: {text: ''},
              subtitle: {text: ''},
              yAxis: {title: 'Redemptions'},
              xAxis: {
                type: 'datetime',
                minTickInterval: 24 * 3600 * 1000,
                dateTimeLabelFormats: { // don't display the dummy year
                  month: '%e. %b',
                  year: '%b'
                },
                title: {
                  text: 'Date'
                }
              },
              tooltip: {
                pointFormat: '{series.name}: {point.y}'
              },
              plotOptions: {
                line: {
                  dataLabels: {enabled: true},
                }
              },
              series: []
            },
            render: function (response) {
              const cleanDate = (t) => {
                const date = new Date(t);
                return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
              }

              const dealIds = [];
              const deals = {};
              for (let d of response) {
                if (dealIds.indexOf(d.deal_id) === -1) {
                  dealIds.push(d.deal_id)
                  deals[d.deal_id] = d.name;
                }
              }
              this.chart.series = dealIds.map(dealId => ({
                    name: deals[dealId],
                    data: response.filter(x => x.deal_id === dealId).map(x => [cleanDate(x.date), Number(x.redemptions)]),
                  })
              );
            }
          }
        },
        redemptionsByDay: {
          tableData: {
            params: {functionName: 'redemptionsByTime', timeFrame: 'Day'},
          },
          chartData: {
            label: `Redemption by Day`,
            chart: {
              chart: {
                type: 'column'
              },
              title: {text: ''},
              yAxis: {title: ''},
              xAxis: {categories: []},
              tooltip: {
                pointFormat: '{series.name}: {point.y}'
              },
              plotOptions: {
                column: {
                  size: '100%',
                  pointPadding: 0.2,
                  borderWidth: 0
                }
              },
              series: []
            },
            render: function (response) {
              const redemptions = [];
              for (const day of ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']) {
                redemptions.push({redemptions: 0, day});
              }
              for (const d of response) {
                const f = redemptions.find(x => x.day === d.day);
                if (f) f.redemptions = d.redemptions;
              }

              this.chart.xAxis.categories = redemptions.map(x => x.day);
              this.chart.series = [{
                name: 'Redemptions',
                data: redemptions.map(x => Number(x.redemptions)),
                dataLabel: {enabled: true}
              }];
            }
          }
        },
        redemptionsByHour: {
          tableData: {
            params: {functionName: 'redemptionsByTime', timeFrame: 'Hour'},
          },
          chartData: {
            label: `Redemption by Hour`,
            chart: {
              chart: {
                type: 'column'
              },
              title: {text: ''},
              yAxis: {title: ''},
              xAxis: {categories: []},
              tooltip: {
                pointFormat: '{series.name}: {point.y}'
              },
              plotOptions: {
                column: {
                  size: '100%',
                  pointPadding: 0.2,
                  borderWidth: 0
                }
              },
              series: []
            },
            render: function (response) {
              const redemptions = [];
              for (const ap of ['AM', 'PM']) {
                for (const hour of [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]) {
                  redemptions.push({redemptions: 0, hour: hour + ' ' + ap});
                }
              }
              for (const d of response) {
                const f = redemptions.find(x => x.hour === d.hour);
                if (f) f.redemptions = d.redemptions;
              }

              this.chart.xAxis.categories = redemptions.map(x => x.hour);
              this.chart.series = [{
                name: 'Redemptions',
                data: redemptions.map(x => Number(x.redemptions)),
                dataLabel: {enabled: true}
              }];
            }
          }
        },
        customerRedemptions: {
          tableData: {
            label: `Redemptions Detail`,
            columnOptions: {
              product: {name: 'Product'},
              redemptionDate: {
                name: 'Redemption date',
                format: 'dateTime'
              }
            },
            checkedColumns: ['product', 'redemptionDate'],
            params: {functionName: 'customerRedemptions'},
          },
        },
      }
    })
  },
  computed: {
    displayFilters() {
      return {
        dateRange: {
          name: `Redemption Date`,
          sort: 1,
        },
        deals: {
          name: 'Pass(es)',
          data: [],
          sort: 2,
          multiselect: true,
        }
      };
    }
  },
  async mounted() {
    this.reportHelper = new ReportHelper(this);
    await this.reportHelper.init();
  }
}
</script>

<style lang="scss" scoped>
@media (min-width: 1264px) {
  .cols-lg-5 {
    width: 20% !important;
    max-width: 20% !important;
    flex-basis: 20% !important;
  }
}
</style>